import { render, staticRenderFns } from "./AudioRecordingDuration.vue?vue&type=template&id=0a1011c2&scoped=true&"
import script from "./AudioRecordingDuration.vue?vue&type=script&lang=ts&"
export * from "./AudioRecordingDuration.vue?vue&type=script&lang=ts&"
import style0 from "./AudioRecordingDuration.vue?vue&type=style&index=0&id=0a1011c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1011c2",
  null
  
)

export default component.exports